import React, { useEffect, useState } from 'react'

import { useSectionConfig } from 'conversations/hooks/useSections'
import {
  useSectionSubscriptionChannel,
  useSharedSectionSubscriptionChannel,
} from 'conversations/hooks/useSectionSubscriptionChannel'
import { hasUserSubscriptionAllSections } from 'conversations/modules/gates/selectors'
import { Pill } from 'conversations/utils/pillUtil'
import { useSelector } from 'react-redux'
import { localStore } from 'shared/utils/storage'

import { ExpandableSection } from '@driftt/conversation-components'

import styles from './styles.module.css'

const ConversationSidebarSection: React.FC<{
  children: JSX.Element
  renderSectionHeader: (props: any) => JSX.Element
  initiallyOpen?: boolean
  sectionID?: string
  selectedPill: Pill
}> = ({ children, initiallyOpen, renderSectionHeader, sectionID, selectedPill }): JSX.Element => {
  const LS_KEY = `sidebar_${sectionID}_expanded`
  const currentLSValue = localStore.get(LS_KEY)
  const [expanded, setExpanded] = useState(() => {
    if (currentLSValue === undefined || currentLSValue === null) {
      return !!initiallyOpen
    } else {
      return !!currentLSValue
    }
  })

  useEffect(() => {
    if ((!!currentLSValue && currentLSValue !== selectedPill) || initiallyOpen) {
      localStore.set(LS_KEY, selectedPill)
    }
  }, [selectedPill, LS_KEY, currentLSValue, initiallyOpen])

  const hasSubChannelAllSections = useSelector(hasUserSubscriptionAllSections)
  const sectionConfig = useSectionConfig(sectionID)
  const subscribeToSection = hasSubChannelAllSections ? true : sectionConfig?.type === 'all-convos'
  const doSubscribe = expanded && subscribeToSection
  useSectionSubscriptionChannel(sectionConfig?.subscriptionId, doSubscribe)
  useSharedSectionSubscriptionChannel()

  return (
    <div className={styles.filteredConversationsSidebarSection}>
      <ExpandableSection
        expanded={expanded}
        onClick={() => {
          if (expanded) {
            localStore.removeItem(LS_KEY)
          } else {
            localStore.set(LS_KEY, selectedPill)
          }
          setExpanded((prev) => !prev)
        }}
        headerClassName={styles.convoSectionHeader}
        hasBottomBorder={false}
        contentClassName={styles.convoSectionContent}
        renderSectionHeader={renderSectionHeader}>
        {children}
      </ExpandableSection>
    </div>
  )
}

export default ConversationSidebarSection
